var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5 0C19.6109 0 23.5533 1.63303 26.4602 4.53984C29.367 7.44666 31 11.3891 31 15.5C31 19.6109 29.367 23.5533 26.4602 26.4602C23.5533 29.367 19.6109 31 15.5 31C11.3891 31 7.44666 29.367 4.53984 26.4602C1.63303 23.5533 0 19.6109 0 15.5C0 11.3891 1.63303 7.44666 4.53984 4.53984C7.44666 1.63303 11.3891 0 15.5 0ZM13.5691 18.5579L10.1259 15.1125C10.0025 14.9891 9.85595 14.8911 9.69467 14.8243C9.53339 14.7575 9.36053 14.7232 9.18596 14.7232C9.0114 14.7232 8.83854 14.7575 8.67726 14.8243C8.51598 14.8911 8.36944 14.9891 8.246 15.1125C7.99671 15.3618 7.85665 15.6999 7.85665 16.0525C7.85665 16.405 7.99671 16.7431 8.246 16.9924L12.6303 21.3767C12.7534 21.5008 12.8998 21.5992 13.0611 21.6664C13.2225 21.7336 13.3955 21.7682 13.5702 21.7682C13.745 21.7682 13.918 21.7336 14.0794 21.6664C14.2407 21.5992 14.3871 21.5008 14.5102 21.3767L23.5888 12.2959C23.7139 12.173 23.8134 12.0265 23.8816 11.8649C23.9498 11.7034 23.9853 11.5299 23.9861 11.3545C23.9869 11.1791 23.953 11.0053 23.8863 10.8431C23.8196 10.6809 23.7215 10.5335 23.5976 10.4094C23.4736 10.2854 23.3263 10.187 23.1642 10.1202C23.0021 10.0533 22.8283 10.0192 22.653 10.0198C22.4776 10.0204 22.3041 10.0557 22.1424 10.1237C21.9807 10.1917 21.8341 10.2911 21.7111 10.416L13.5691 18.5579Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.fa8050530ec25a0187cf2d05a85e7815.svg";
export { ForwardRef as ReactComponent };